'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var specialtyMapping = exports.specialtyMapping = function specialtyMapping(specialties, specialtyId) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = specialties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var specialty = _step.value;

      if (specialty.id === specialtyId) {
        return specialty;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return null;
};

var isTopLevelSpecialty = exports.isTopLevelSpecialty = function isTopLevelSpecialty() {
  var specialty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return specialty.parent_name === 'abstract_top_level_keyword';
};

var isSubspecialty = exports.isSubspecialty = function isSubspecialty() {
  var specialty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return !isTopLevelSpecialty(specialty);
};

var extractTopLevelSpecialty = exports.extractTopLevelSpecialty = function extractTopLevelSpecialty() {
  var specialties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return specialties.filter(isTopLevelSpecialty).length ? specialties.filter(isTopLevelSpecialty)[0] : null;
};

var extractSubSpecialties = exports.extractSubSpecialties = function extractSubSpecialties() {
  var specialties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return specialties.filter(isSubspecialty);
};

var getSpecialtyByNameOrPractitioner = exports.getSpecialtyByNameOrPractitioner = function getSpecialtyByNameOrPractitioner() {
  var specialties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var choices = specialties.filter(function (keyword) {
    return keyword.keyword_type === 'specialty';
  }).filter(function (specialty) {
    return specialty.name.trim().toLowerCase() === name.trim().toLowerCase();
  });
  choices = [].concat(_toConsumableArray(choices), _toConsumableArray(specialties.filter(function (specialty) {
    return specialty.practitioner && specialty.practitioner.trim().toLowerCase() === name.trim().toLowerCase();
  })));
  return choices.length ? choices[0] : null;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-utils/lib/specialty-mapping.js
// module id = 609
// module chunks = 0